/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient, HttpRequest, HttpResponse,
  HttpHeaders, HttpParams
} from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';

@Injectable()
export class ManagerAppVersionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  managerAppVersionDevicesResponse(params?: ManagerAppVersionsService.ListDevicesParams): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    const __body: any = null;

    if (params != null && params.page != null) {
      __params = __params.set('page', params.page.toString());
    }
    if (params != null && params.limit != null) {
      __params = __params.set('limit', params.limit.toString());
    }
    if (params != null && params.current_version != null && params.current_version !== '') {
      __params = __params.set('current_version', params.current_version.toString());
    }
    if (params != null && params.role_id != null && params.role_id !== '') {
      __params = __params.set('role_id', params.role_id.toString());
    }

    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/app-version/devices`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerAppVersionDevices(params?: ManagerAppVersionsService.ListDevicesParams): Observable<any> {
    return this.managerAppVersionDevicesResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerAppVersionsListResponse(): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;

    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/app-versions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerAppVersionsList(): Observable<any> {
    return this.managerAppVersionsListResponse().pipe(
      map(_r => _r.body)
    );
  }

  managerBulkUpdateAppVersionPoliciesResponse(body: any): Observable<HttpResponse<any>> {
    const __params = this.newParams();
    const __headers = new HttpHeaders();

    const req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/manager/app-version-policies/bulk-update`,
      body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerBulkUpdateAppVersionPolicies(body: any): Observable<any> {
    return this.managerBulkUpdateAppVersionPoliciesResponse(body).pipe(
      map(_r => _r.body)
    );
  }
}

export module ManagerAppVersionsService {
  export interface ListDevicesParams {
    page?: number;
    limit?: number;
    current_version?: string;
    role_id?: number | string;
  }
}
